<template>
  <!-- :default-active="$route.name" 解决面包屑切换页面时导航菜单不切换问题 -->
  <el-menu
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    :collapse="isCollapse"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    router
    :default-active="$route.name"
  >
    <h2>{{ isCollapse ? "后台" : "后台管理系统" }}</h2>

    <el-menu-item
      v-for="item in noChildren"
      :key="item.name"
      :index="item.name"
      :route="item.path"
      @click="selectMenu(item)"
    >
      <i :class="`el-icon-${item.icon}`"></i>
      <span slot="title">{{ item.label }}</span>
    </el-menu-item>

    <el-submenu
      v-for="item in hasChildren"
      :key="item.label"
      :index="item.label"
    >
      <template slot="title">
        <i :class="`el-icon-${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </template>
      <el-menu-item-group v-for="subItem in item.children" :key="subItem.name">
        <el-menu-item
          :route="subItem.path"
          :index="subItem.name"
          @click="selectMenu(subItem)"
          >{{ subItem.label }}</el-menu-item
        >
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
import Cookie from "js-cookie";
import { mapState, mapMutations } from "vuex";
export default {
  name: "CommonAside",
  data() {
    return {
      menu: [
        {
          path: "/home",
          name: "home",
          label: "首页",
          icon: "s-home",
          hinde: false,
        },
        {
          path: "/Banner",
          name: "Banner",
          label: "Banner列表",
          icon: "s-custom",
          hinde: false,
        },
        {
          path: "/adminList",
          name: "adminList",
          label: "管理员列表",
          icon: "s-custom",
          hinde: false,
        },
        {
          path: "/user",
          name: "user",
          label: "用户管理",
          icon: "user",
          hinde: false,
        },
        {
          path: "/ClassList",
          name: "ClassList",
          label: "商品分类",
          icon: "s-grid",
          hinde: false,
        },
        {
          path: "/mall",
          name: "mall",
          label: "商品管理",
          icon: "video-play",
          hinde: false,
        },
        // {
        //   label: "其他",
        //   icon: "location",
        //   children: [
        //     {
        //       path: "/page1",
        //       name: "page1",
        //       label: "页面1",
        //       icon: "setting",
        //       hinde: false,
        //     },
        //     {
        //       path: "/page2",
        //       name: "page2",
        //       label: "页面2",
        //       icon: "setting",
        //       hinde: false,
        //     },
        //   ],
        // },
        {
          path: "/userinfo",
          name: "userinfo",
          label: "个人中心",
          hinde: true,
        },
      ],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    ...mapMutations("tab", ["selectMenu"]),
  },
  computed: {
    ...mapState("tab", ["isCollapse"]),
    menuData() {
      // console.log(JSON.parse(Cookie.get('menu')))
      return this.menu.filter((item) => !item.hinde);
    },
    //没有子菜单
    noChildren() {
      return this.menuData.filter((item) => !item.children);
    },
    //有子菜单
    hasChildren() {
      return this.menuData.filter((item) => item.children);
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu {
  height: 100vh;
  min-height: 100vh;
  border-right: 0px;
  h2 {
    color: #fff;
    text-align: center;
    line-height: 46px;
    font-size: 18px;
    font-weight: 400;
  }
}
</style>
